module.exports = __webpack_public_path__ + "static/media/1302261.f25a0bd8.jpg";